import { render, staticRenderFns } from "./OverlayPopup.vue?vue&type=template&id=48caaa17&"
import script from "./OverlayPopup.vue?vue&type=script&lang=js&"
export * from "./OverlayPopup.vue?vue&type=script&lang=js&"
import style0 from "./OverlayPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports